import React from "react";
import { NavLink } from "react-router-dom";
import RealTimeUpdates from "../../assets/images/Data-enrichment/real-time-updates.png";
import EnhancedLeadProfiles from "../../assets/images/Data-enrichment/enhanced-lead-profiles.png";
import ImprovedTargeting from "../../assets/images/Data-enrichment/improved-tragetting.png";
import IncreasedAccuracy from "../../assets/images/Data-enrichment/increased-accuracy.png";
import SeamlessIntegration from "../../assets/images/Data-enrichment/seamless-integration.png";
import Testimonials from "../../components/home/Testimonials";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import DataEnrichBanner from "../../assets/images/Data-enrichment/data-enrichment-banner.png";
import Cta from "../../components/cta/cta";

const DataEnrichPage = () => {
  const customGridFirst = "430px 1fr";
  const customGridSecond = "1fr 430px";

  return (
    <>
      <div className="dataEnrichment-wrapper">
        <section className="dataE-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <p
                  className="heading16px text-primary-color roboto-regular mb10"
                  style={{ fontWeight: "bold" }}
                >
                  ELEVATE YOUR LEAD QUALITY
                </p>
                <h1 className="heading39px roboto-bold mb20 text-color-131415">
                  Supercharge Your Campaigns with <br /> Accurate and
                  Comprehensive Data
                </h1>
                <p className="heading16px roboto-regular mb30 text-color-131415">
                  BeyondLeadz's AI Lead Enrichment feature takes your lead
                  generation to the next level <br /> by enhancing your existing
                  data with additional, critical information.
                </p>
                <ul className="btn-sec mb30">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Subscribe Now
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>

                <img
                  src={DataEnrichBanner}
                  className="img-responsive position-relative"
                  alt="Supercharge Your Campaigns with Accurate and Comprehensive Data"
                />
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="dataE-three">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb60 heading29px text-center">
                Your Target, Our Precision
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridFirst,
                  "--grid-gap": "24px",
                  marginBottom: "24px",
                }}
              >
                <div className="common-shadow common-box de1">
                  <div className="text-center">
                    <img
                      src={RealTimeUpdates}
                      alt="Real-Time Updates"
                      className="img-responsive"
                    />
                  </div>
                  <h3 className="roboto-bold heading20px mb10 mt30">
                    Real-Time Updates
                  </h3>
                  <p className="roboto-regular heading16px">
                    Keep your data fresh and relevant with real-time updates
                    from trusted third-party data providers.
                  </p>
                </div>

                <div className="common-shadow common-box de2">
                  <div className="text-center">
                    <img
                      src={EnhancedLeadProfiles}
                      alt="Enhanced Lead Profiles"
                      className="img-responsive"
                    />
                  </div>
                  <h3 className="roboto-bold heading20px mb10 mt30">
                    Enhanced Lead Profiles
                  </h3>
                  <p className="roboto-regular heading16px">
                    Automatically enrich your lead data with additional
                    information, such as job titles, company size, industry, and
                    more, giving you a fuller picture of your potential
                    customers.
                  </p>
                </div>
              </div>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridSecond,
                  "--grid-gap": "24px",
                  marginBottom: "24px",
                }}
              >
                <div className="common-shadow common-box de3">
                  <div className="text-center">
                    <img
                      src={ImprovedTargeting}
                      alt="Improved Targeting"
                      className="img-responsive"
                    />
                  </div>
                  <h3 className="roboto-bold heading20px mb10 mt30">
                    Improved Targeting
                  </h3>
                  <p className="roboto-regular heading16px">
                    Use enriched data to create more precise audience segments,
                    enabling more targeted and effective marketing campaigns.
                  </p>
                </div>

                <div className="common-shadow common-box de4">
                  <div className="text-center">
                    <img
                      src={IncreasedAccuracy}
                      alt="Increased Accuracy"
                      className="img-responsive"
                    />
                  </div>
                  <h3 className="roboto-bold heading20px mb10 mt30">
                    Increased Accuracy
                  </h3>
                  <p className="roboto-regular heading16px">
                    Reduce errors and ensure that your marketing and sales teams
                    are working with the most accurate and up-to-date
                    information available.
                  </p>
                </div>
              </div>

              <div className="common-shadow common-box de5 max-width950">
                <div className="grid-auto-fit align-items-center">
                  <div>
                    <h3 className="roboto-bold heading20px mb10 mt30">
                      Seamless Integration
                    </h3>
                    <p className="roboto-regular heading16px">
                      Easily integrate enriched data into your existing CRM,
                      marketing automation tools, and other business systems for
                      a streamlined workflow.
                    </p>
                  </div>
                  <div>
                    <img
                      src={SeamlessIntegration}
                      alt="Seamless Integration"
                      className="img-responsive"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default DataEnrichPage;
